import { cn } from "@/lib/utils"
import type { GalleryRow } from "@/types/content-gallery"

import { GalleryTile } from "./gallery-tile"

/**
 * OKS-39 — Responsive grid of `<GalleryTile>`s.
 *
 * Breakpoints (UX Spec §3.3):
 *   - <640 px (mobile):  2 columns
 *   - ≥640 px (tablet):  3 columns
 *   - ≥1024 px (desktop): 4 columns
 *
 * Semantic markup: `<ul role="list">` + `<li role="listitem">` so screen
 * readers navigate the grid as a list rather than a wall of divs
 * (UX Spec §8). `gap` widens slightly at `sm:` to keep tile density
 * comfortable on tablet/desktop.
 */
interface GalleryGridProps {
  rows: readonly GalleryRow[]
  className?: string
}

export function GalleryGrid({ rows, className }: GalleryGridProps) {
  return (
    <ul
      role="list"
      className={cn(
        "grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4",
        className,
      )}
      data-testid="gallery-grid"
    >
      {rows.map((row) => (
        <li role="listitem" key={row.id}>
          <GalleryTile row={row} />
        </li>
      ))}
    </ul>
  )
}
